<template>
	<div class="page-mdl">
		<!-- 选项卡切换 -->
		<div class="m-tag-box">
			<span :class="{act:item.columnId==columnId}" @click="changeNewTag(item.columnId)"
				v-for="(item,index) in cateList" :key="item.columnId">{{item.columnName}}</span>
			<!-- <span>通知公告</span> -->
		</div>
		
		<!-- 新闻列表 -->
		<van-list
			v-if="listInfo.list.length>0"
			v-model="listInfo.loading"
			:finished="listInfo.finished"
			finished-text="没有更多了"
			:offset="30"
			@load="getNewList"
		>
			<ul class="news-list">
				<li v-for="(item,index) in listInfo.list" :key="item.contentId" @click="goDetail(item.contentId)">
					<h3 class="text-elli2">{{item.contentTitle}}</h3>
					<p class="text-elli2">{{item.contentDesc}}</p>
					<div class="date-time">{{item.createdDt.substring(0,10)}}  发表</div>
				</li>
			</ul>
		</van-list>
		<van-empty v-if="listInfo.finished && !listInfo.list.length>0"  description="暂无内容" />
		
		
	</div>
</template>

<script>
import { getList } from '@/static/js/list-vant.js'
export default {
	name: 'newsList',
	components:{
		
	},
	data () {
		return {
			firstCateId:'',	//一级栏目id
			cateList:[],	//二级栏目列表
			secondCateId:'',	//当前二级栏目id
			
			
			secondInfo:{
				title:'',
				list:[
					// { title:'新闻动态',  },
					// { title:'政策文件',  }
				],
				columnId:''
			},
			listInfo:{	//开放课程
				list:[],
				pageNum:1,
				pageSize:10,
				total:0,
				loading: true,
				finished: false,
			},
			
			
		}
	},
	
	async created(){
		await this.$onLaunched;		//监听加载了APP.vue中的onLaunched的异步后执行
		this.firstCateId = this.$route.params.firstCateId
		this.getSecondColumnList()
	},
  
	
	watch:{
		$route(to,from){
			this.firstCateId = to.params.firstCateId
			this.getSecondColumnList()
		},
	},
  
	methods:{
		
		//栏目切换
		changeNewTag(columnId){
			this.goUrl({ name:'news', params:{firstCateId:this.firstCateId}, query:{ secondCateId: columnId}})
		},
		
		// changeNewTag(columnId){
		// 	this.columnId = columnId
		// 	this.getNewList(true)
		// 	window.scrollTo(0,0);
		// },

		//查询二级栏目
		getSecondColumnList(){
			let { firstCateId } = this
			//获取二级栏目列表
			this.$axios({
				url:`/jxedu/api/site/secondColumnList/${firstCateId}`,
			}).then(res=>{
				let list = res.data
				this.cateList = list
				const { secondCateId } = this.$route.query	
				this.columnId = secondCateId || list[0].columnId
				this.getNewList(true)
			})
		},
		
		//查询门户首页二级栏目数据
		getNewList(isReach){	//isReach:是否刷新充值
			const { columnId } = this
			getList({
				url:`/jxedu/api/site/columnContents`,		//必传，接口地址，不用前缀
				page:this,				//必传,当前页面的this
				isReach,
				listName:'listInfo',
				data:{
					columnId,
				},
				cbListFn:(res)=>{
					return res.data.rows	//这里接口返回的数据层级，看列表属于哪一级
				},
				handleFn:(item)=>{
					item.contentDesc = this.$common.removeHTMLTag(item.contentDesc)
					item.createdDt = item.createdDt.replace(/\//g,"-")
					return item
				}
			})
		},
		
		//跳转新闻详情
		goDetail(contentId){
			this.goUrl({name:'newsDetail',params:{ id:contentId }, query:{ parentId : this.secondInfo.columnId }})
		},
		
	}
}
</script>

<style lang="less" scoped>
@vm: 7.5vw;
body{ background:#F9F9F9; }
.m-tag-box{
	position:fixed; top:0; left:0; width:100%; box-sizing: border-box;
}
.news-list{
	padding: 132/@vm 32/@vm 0;
	li{
		background: #FFFFFF; box-shadow: 0 2/@vm 14/@vm 0 rgba(0, 0, 0, 0.1); border-radius:6/@vm;
		margin-bottom:28/@vm;  border: 2/@vm solid #EEEEEE; padding:28/@vm 30/@vm;
		h3{ font-size:32/@vm; line-height:42/@vm; color:#333333; font-weight: bold; margin-bottom:20/@vm; }
		p{ font-size:24/@vm; line-height:32/@vm; color:#666666; letter-spacing: 1px;}
		.date-time{ border-top:2/@vm solid #EEEEEE; padding-top:20/@vm; margin-top:32/@vm; font-size:24/@vm; color:#999999;}
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/news-list/tpl-mobile.vue